import { createModelStore } from '@/shared/stores/create-model-store'
import { model13InitialModel } from './initial-state'
import { model13DimensionHandlers } from './dimensions'

export const useModel13Store = createModelStore({
  initialModel: model13InitialModel,
  dimensionHandlers: model13DimensionHandlers,
})
